"use strict";

var DpdAddressSuggestionService = function(locationSelector, regionSelector, zipCodeSelector, streetSelector, countryCodeSelector, streetSelectedFlagSelector, type) {

    var suggestionPopupSelector = '#suggestionPopup-' + type;
    var suggestionListSelector = '#suggestion-list-' + type;
    var suggestionListItemSelector = '#suggestion-list-' + type + ' li';
    var suggestionItemTemplateSelector = '#suggestion-li-template-' + type;
    var suggestionNoResultsSelector = '#suggestion-no-results-' + type;

    var data = {
        "location" : {
            id : 'location',
            selector : locationSelector,
            timer : undefined,
            timeoutValue : 500,
            textHolder : undefined,
            textHolderReset : false,
            searchTextMinLength : 3,
            suggestionList : undefined,
            selectedSuggestion : {
                name : undefined,
                administrativeLevels : undefined
            },
            suggestionSearchUrl : '/suggestion-location-ajax',
            getAjaxRequestData : getAjaxRequestLocationData,
            getSuggestionName : getLocationSuggestionName,
            getSuggestionAdministrativeLevels : getLocationSuggestionAdministrativeLevels
        },
        "zipcode" : {
            id : 'zipcode',
            selector : zipCodeSelector,
            timer : undefined,
            timeoutValue : 100,
            textHolder : undefined,
            textHolderReset : false,
            searchTextMinLength : 1,
            suggestionList : undefined,
            selectedSuggestion : {
                name : undefined
            },
            suggestionSearchUrl : '/suggestion-zipcode-ajax',
            getAjaxRequestData : getAjaxRequestZipCodeData,
            getSuggestionName : getZipCodeSuggestionName
        },
        "street" : {
            id : 'street',
            selector : streetSelector,
            timer : undefined,
            timeoutValue : 500,
            textHolder : undefined,
            textHolderReset : false,
            searchTextMinLength : 3,
            suggestionList : undefined,
            selectedSuggestion : {
                name : undefined,
                displayName : undefined
            },
            suggestionSearchUrl : '/dpd-suggestion-street-ajax',
            getAjaxRequestData : getAjaxRequestStreetData,
            getSuggestionName : getStreetSuggestionName
        }
    };

    var locationData = data['location'];
    var zipCodeData = data['zipcode'];
    var streetData = data['street'];
    var regionSel = regionSelector;
    var countryCodeSel = countryCodeSelector;
    var streetSelectedFlagField = streetSelectedFlagSelector ? $(streetSelectedFlagSelector) : undefined;
    var lastValidatedStreetFieldSelector = type === 'different'
        ? '#differentAddressLastValidatedStreet'
        : '#invoiceAddressLastValidatedStreet';
    var lastValidatedStreetField = $(lastValidatedStreetFieldSelector);


    window.THEME.$document.on('countryChangedEvent', function(){
        Object.keys(data).forEach(function(key) {
            data[key].textHolderReset = true;
        });
    });

    function getRegionValue() {
        if (regionSel === undefined) {
            return undefined;
        }

        var $regionElement = $(regionSel);
        if ($regionElement.length === 0) {
            return undefined;
        }

        var regionValue = $regionElement.val();
        if (regionValue !== undefined && regionValue !== null && regionValue.length > 0) {
            return regionValue;
        }

        if ($regionElement.data('select2') !== undefined) {
            var select2Data = $regionElement.select2('data');
            if (select2Data !== undefined && select2Data !== null && select2Data.length > 0 && select2Data[0].id !== undefined && select2Data[0].id !== null && select2Data[0].id.length > 0) {
                return select2Data[0].id;
            }
        }

        return undefined;
    }

    var resetStreetSelectionState = function() {
        clearData(streetData);
        $(streetData.selector).val('');
        setStreetSelectedFromSuggestion(false);
        setLastValidatedStreet('');
    };

    var resetLocationSelectionState = function() {
        clearData(locationData);
        $(locationData.selector).val('').trigger('change');
    };

    if (regionSel !== undefined) {
        $(document).on('change select2:select select2:clear', regionSel, function() {
            resetLocationSelectionState();
            resetStreetSelectionState();
        });
    }

    if (countryCodeSel !== undefined) {
        $(document).on('change', countryCodeSel, function() {
            resetStreetSelectionState();
        });
    }

    $(document).on('change select2:select select2:clear', locationSelector + ', ' + zipCodeSelector, function() {
        resetStreetSelectionState();
    });

    /*LOCATION*/
    function handleLocationFieldKeyUp() {
        resetStreetSelectionState();
        handleFieldKeyUp($(locationData.selector), locationData);
    }

    function handleLocationFieldFocus() {
        handleFieldFocus(locationData);
    }

    function handleLocationFieldFocusOut() {
        handleFieldFocusOut(locationData);
    }

    function getAjaxRequestLocationData(searchText) {
        searchText = encodeURIComponent(searchText)
        var ajaxRequestData = {
            'location-prefix' : searchText
        };
        var countryCode = getCountryCode();
        if (countryCode) {
            ajaxRequestData['country-code'] = countryCode;
        }
        if (streetData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['street'] = encodeURIComponent(streetData.selectedSuggestion.name);
        }
        if (zipCodeData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['zipcode'] = zipCodeData.selectedSuggestion.name;
        }
        return ajaxRequestData;
    }

    function getAjaxRequestLocationAdministrativeLevelsData() {
        var ajaxAdministrativeLevels = {};
        if (locationData.selectedSuggestion.administrativeLevels !== undefined) {
            Object.keys(locationData.selectedSuggestion.administrativeLevels).sort().forEach(function(level) {
                ajaxAdministrativeLevels['administrativeLevel' + level] = locationData.selectedSuggestion.administrativeLevels[level];
            });
        }
        return ajaxAdministrativeLevels;
    }

    function getLocationSuggestionName(suggestion) {
        return suggestion["locationName"];
    }

    function getLocationSuggestionAdministrativeLevels(suggestion) {
        var administrativeLevels = "";
        var administrativeLevelsMap = suggestion["administrativeLevels"];
        Object.keys(administrativeLevelsMap).sort().forEach(function(level) {
            administrativeLevels += (administrativeLevelsMap[level] + ", ");
        });
        if (administrativeLevels.length > 0) {
            administrativeLevels = "(" + administrativeLevels.substring(0, administrativeLevels.length - 2) + ")";
        }
        return administrativeLevels;
    }

    /*ZIP CODE*/
    function handleZipCodeFieldKeyUp() {
        handleFieldKeyUp($(zipCodeData.selector), zipCodeData);
    }

    function handleZipCodeFieldFocus() {
        handleFieldFocus(zipCodeData);
    }

    function handleZipCodeFieldFocusOut() {
        handleFieldFocusOut(zipCodeData);
    }

    function getAjaxRequestZipCodeData(searchText) {
        var ajaxRequestData = {
            'zipcode-prefix' : searchText
        };
        var countryCode = getCountryCode();
        if (countryCode) {
            ajaxRequestData['country-code'] = countryCode;
        }
        if (locationData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['location'] = encodeURIComponent(locationData.selectedSuggestion.name);
            $.extend(ajaxRequestData, getAjaxRequestLocationAdministrativeLevelsData());
        }
        if (streetData.selectedSuggestion.name !== undefined) {
            ajaxRequestData['street'] = encodeURIComponent(streetData.selectedSuggestion.name);
        }
        return ajaxRequestData;
    }

    function getZipCodeSuggestionName(suggestion) {
        return suggestion;
    }

    /*STREET*/
    function handleStreetFieldKeyUp() {
        var currentStreetValue = $(streetData.selector).val();
        var selectedDisplayName = streetData.selectedSuggestion.displayName;
        var normalizedCurrentStreetValue = normalizeStreetForCompare(currentStreetValue);
        var normalizedSelectedDisplayName = normalizeStreetForCompare(selectedDisplayName);

        if (normalizedSelectedDisplayName.length === 0 || normalizedSelectedDisplayName !== normalizedCurrentStreetValue) {
            setStreetSelectedFromSuggestion(false);
            setLastValidatedStreet('');
        } else {
            setStreetSelectedFromSuggestion(true);
            setLastValidatedStreet(selectedDisplayName || currentStreetValue);
        }

        handleFieldKeyUp($(streetData.selector), streetData);
    }

    function handleStreetFieldFocus() {
        handleFieldFocus(streetData);
    }

    function handleStreetFieldFocusOut() {
        handleFieldFocusOut(streetData);
        validateStreetSelectionAgainstSuggestions();
    }

    function getStreetSearchQueryWithoutPrefix(searchText) {
        var normalizedSearch = normalizeStreetForCompare(searchText);
        var streetNamePart = getStreetNamePart(normalizedSearch);

        if (streetNamePart && streetNamePart.length > 0) {
            return streetNamePart;
        }

        return normalizedSearch;
    }

    function getAjaxRequestStreetData(searchText) {
        var streetSearchQuery = getStreetSearchQueryWithoutPrefix(searchText);
        if (streetSearchQuery === undefined || streetSearchQuery === null || streetSearchQuery.length === 0) {
            return undefined;
        }

        var locationValue = $(locationData.selector).val();
        var regionValue = getRegionValue();

        if (locationValue === undefined || locationValue === null || locationValue.length === 0 ||
            regionValue === undefined || regionValue === null || regionValue.length === 0) {
            return undefined;
        }

        var ajaxRequestData = {
            'street-substring' : encodeURIComponent(streetSearchQuery),
            'location' : encodeURIComponent(locationValue),
            'region' : encodeURIComponent(regionValue)
        };

        return ajaxRequestData;
    }

    function getStreetSuggestionName(suggestion) {
        var streetName = suggestion.name || '';
        var streetType = suggestion.type || '';

        if (streetType.length > 0 && streetName.length > 0) {
            return streetType + ' ' + streetName;
        }

        return streetName;
    }

    function getStreetSuggestionDisplayNameByIndex(index) {
        if (streetData.suggestionList === undefined || streetData.suggestionList[index] === undefined) {
            return undefined;
        }

        return getStreetSuggestionName(streetData.suggestionList[index]);
    }

    function validateStreetSelectionAgainstSuggestions() {
        var currentStreetValue = $(streetData.selector).val();

        if (currentStreetValue === undefined || currentStreetValue === null || currentStreetValue.length === 0) {
            setStreetSelectedFromSuggestion(false);
            setLastValidatedStreet('');
            streetData.selectedSuggestion.name = undefined;
            streetData.selectedSuggestion.displayName = undefined;
            return;
        }

        if (isEmptyList(streetData.suggestionList)) {
            setStreetSelectedFromSuggestion(false);
            setLastValidatedStreet('');
            return;
        }

        var normalizedCurrentStreetValue = normalizeStreetForCompare(currentStreetValue);

        for (var i = 0; i < streetData.suggestionList.length; i++) {
            var suggestionDisplayName = getStreetSuggestionName(streetData.suggestionList[i]);
            if (streetsAreEquivalent(currentStreetValue, suggestionDisplayName)) {
                streetData.selectedSuggestion.name = suggestionDisplayName;
                streetData.selectedSuggestion.displayName = suggestionDisplayName;
                $(streetData.selector).val(suggestionDisplayName);
                setStreetSelectedFromSuggestion(true);
                setLastValidatedStreet(suggestionDisplayName);
                return;
            }
        }

        setStreetSelectedFromSuggestion(false);
        setLastValidatedStreet('');
        streetData.selectedSuggestion.name = undefined;
        streetData.selectedSuggestion.displayName = undefined;
    }

    /*HELPERS*/
    var clearData = function(data) {
        updateTextHolder(data, undefined);
        data.suggestionList = undefined;
        data.selectedSuggestion.name = undefined;
        if ('administrativeLevels' in data.selectedSuggestion) {
            data.selectedSuggestion.administrativeLevels = undefined;
        }
        if ('displayName' in data.selectedSuggestion) {
            data.selectedSuggestion.displayName = undefined;
        }
    };

    var handleFieldFocus = function(data) {
        if (!data.textHolderReset && (data.textHolder !== undefined) && (data.textHolder.length > 0)) {
            if ($(data.selector).val() === data.textHolder) {
                populateSuggestionPopup(data.suggestionList, data);
            } else {
                handleFieldKeyUp($(data.selector), data);
            }
        } else {
            handleFieldKeyUp($(data.selector), data);
        }
    };

    var handleFieldFocusOut = function(data) {
        var searchText = $(data.selector).val();
        if ((searchText !== undefined) && (searchText.length > 0) && !isEmptyList(data.suggestionList)) {
            var normalizedSearchText = data.id === 'street'
                ? normalizeStreetForCompare(searchText)
                : searchText.toLowerCase();

            for (var i = 0; i < data.suggestionList.length; i++) {
                var suggestionName = data.getSuggestionName(data.suggestionList[i]);
                var normalizedSuggestionName = data.id === 'street'
                    ? normalizeStreetForCompare(suggestionName)
                    : suggestionName.toLowerCase();

                if (normalizedSearchText === normalizedSuggestionName) {
                    data.selectedSuggestion.name = suggestionName;
                    if (data.id === 'street') {
                        data.selectedSuggestion.displayName = suggestionName;
                        setStreetSelectedFromSuggestion(true);
                        setLastValidatedStreet(suggestionName);
                    }
                    $(data.selector).val(suggestionName).trigger('keyup');
                    break;
                }
            }
        }
    };

    var handleFieldKeyUp = function($this, data) {
        var searchText = $this.val();
        clearTimeout(data.timer);
        if (searchText.length >= data.searchTextMinLength && (data.textHolderReset || data.textHolder !== searchText)) {
            data.timer = setTimeout(function() {
                if (data.selectedSuggestion.name !== undefined && data.selectedSuggestion.name !== searchText) {
                    data.selectedSuggestion.name = undefined;
                    if ('administrativeLevels' in data.selectedSuggestion) {
                        data.selectedSuggestion.administrativeLevels = undefined;
                    }
                }
                triggerSuggestionSearch(searchText, data);
            }, data.timeoutValue);
        } else if (searchText.length < data.searchTextMinLength) {
            clearData(data);
            $(suggestionPopupSelector).hide();
            clearPopupItems($(suggestionListItemSelector));
            $(suggestionListSelector).empty();
        }
    };

    function getStreetSearchFallbackText(searchText) {
        if (searchText === undefined || searchText === null) {
            return undefined;
        }

        var normalizedSearch = String(searchText)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\./g, ' ')
            .replace(/,/g, ' ')
            .replace(/\s+/g, ' ')
            .trim();

        if (normalizedSearch.length === 0) {
            return undefined;
        }

        var tokens = normalizedSearch.split(' ');
        if (tokens.length <= 1) {
            return undefined;
        }

        var firstToken = tokens[0];
        var fallbackPrefix = STREET_PREFIX_SEARCH_FALLBACK_MAP[firstToken];
        if (fallbackPrefix === undefined) {
            return undefined;
        }

        tokens[0] = fallbackPrefix;
        return tokens.join(' ');
    }

    function deduplicateStreetSuggestions(suggestions) {
        if (isEmptyList(suggestions)) {
            return [];
        }

        var deduplicated = [];
        var uniqueKeys = {};

        for (var i = 0; i < suggestions.length; i++) {
            var suggestion = suggestions[i];
            var key = normalizeStreetForCompare(getStreetSuggestionName(suggestion));

            if (!uniqueKeys[key]) {
                uniqueKeys[key] = true;
                deduplicated.push(suggestion);
            }
        }

        return deduplicated;
    }

    function applySuggestionResult(searchText, data, ajaxSuggestionList) {
        updateTextHolder(data, searchText);
        data.suggestionList = ajaxSuggestionList;
        if (data.id === 'street') {
            hydrateStreetSelectionFromCurrentValue();
        }
        populateSuggestionPopup(ajaxSuggestionList, data);
    }

    var triggerSuggestionSearch = function(searchText, data) {
        var ajaxData = data.getAjaxRequestData(searchText);
        if (ajaxData === undefined || ajaxData === null) {
            updateTextHolder(data, searchText);
            data.suggestionList = [];
            $(suggestionPopupSelector).hide();
            clearPopupItems($(suggestionListItemSelector));
            $(suggestionListSelector).empty();
            return;
        }
        if (data.selectedSuggestion.name !== undefined && data.selectedSuggestion.name !== searchText) {
            data.selectedSuggestion.name = undefined;
            if ('administrativeLevels' in data.selectedSuggestion) {
                data.selectedSuggestion.administrativeLevels = undefined;
            }
        }

        $.ajax({
            method: "GET",
            url: data.suggestionSearchUrl,
            data: ajaxData
        }).done(function (ajaxSuggestionList) {
            if (data.id !== 'street' || !isEmptyList(ajaxSuggestionList)) {
                applySuggestionResult(searchText, data, ajaxSuggestionList);
                return;
            }

            var fallbackSearchText = getStreetSearchFallbackText(searchText);
            if (fallbackSearchText === undefined || fallbackSearchText === searchText) {
                applySuggestionResult(searchText, data, ajaxSuggestionList);
                return;
            }

            var fallbackAjaxData = data.getAjaxRequestData(fallbackSearchText);
            if (fallbackAjaxData === undefined || fallbackAjaxData === null) {
                applySuggestionResult(searchText, data, ajaxSuggestionList);
                return;
            }

            $.ajax({
                method: "GET",
                url: data.suggestionSearchUrl,
                data: fallbackAjaxData
            }).done(function(fallbackSuggestionList) {
                var mergedSuggestions = deduplicateStreetSuggestions((ajaxSuggestionList || []).concat(fallbackSuggestionList || []));
                applySuggestionResult(searchText, data, mergedSuggestions);
            }).fail(function() {
                applySuggestionResult(searchText, data, ajaxSuggestionList);
            });
        }).fail(function () {
            updateTextHolder(data, searchText);
            data.suggestionList = [];
            $(suggestionPopupSelector).hide();
            clearPopupItems($(suggestionListItemSelector));
            $(suggestionListSelector).empty();
        });
    };

    var populateSuggestionPopup = function(suggestionList, data) {
        var $popup = $(suggestionPopupSelector);
        var $suggestionResultsList = $(suggestionListSelector);
        var templateHtml = $(suggestionItemTemplateSelector).html();
        var listHtml = $(suggestionNoResultsSelector).html();

        $suggestionResultsList.empty();
        if (!isEmptyList(suggestionList)) {
            listHtml = "";
            for (var i = 0; i < suggestionList.length; i++) {
                listHtml += templateHtml
                    .replace(/{{index}}/g, i)
                    .replace(/{{name}}/g, data.getSuggestionName(suggestionList[i]))
                    .replace(/{{administrativeNames}}/g, 'getSuggestionAdministrativeLevels' in data ? data.getSuggestionAdministrativeLevels(suggestionList[i]): '');
            }
        }

        $suggestionResultsList.html(listHtml);
        $suggestionResultsList.data('suggestion-type', data.id);
        var $popupItems = $(suggestionListItemSelector);
        $popupItems.each(function(){
            $(this).on("click", function() {
                onSelectSuggestion($(this), data);
            });
        });
        $popup.insertAfter($(data.selector)).show();
        showPopupForSelectedField($(data.selector));
    };

    var onSelectSuggestion = function(suggestion, data) {
        if (suggestion === undefined || suggestion.length === 0) {
            return;
        }

        var suggestionName = suggestion.find("span")[0].textContent;
        var suggestionIndex = suggestion.find("input")[0].value;

        updateTextHolder(data, suggestionName);
        data.selectedSuggestion.name = suggestionName;
        if ('administrativeLevels' in data.selectedSuggestion) {
            data.selectedSuggestion.administrativeLevels = data.suggestionList[suggestionIndex].administrativeLevels;
        }

        if (data.id === 'street') {
            data.selectedSuggestion.displayName = getStreetSuggestionDisplayNameByIndex(suggestionIndex) || suggestionName;
            setStreetSelectedFromSuggestion(true);
            setLastValidatedStreet(data.selectedSuggestion.displayName || suggestionName);
        }
        $(data.selector).val(suggestionName).trigger('keyup');
    };

    var isEmptyList = function(ajaxList) {
        return (ajaxList === undefined || ajaxList.length <= 0);
    };

    function togglePopup(event) {
        var $locationField = $(locationData.selector);
        var $zipcodeField = $(zipCodeData.selector);
        var $streetField = $(streetData.selector);
        var $popup = $(suggestionPopupSelector);

        if ($popup.is(":visible")) {
            if ((!$locationField.is(event.target) && $locationField.has(event.target).length === 0) &&
                (!$zipcodeField.is(event.target) && $zipcodeField.has(event.target).length === 0) &&
                (!$streetField.is(event.target) && $streetField.has(event.target).length === 0)) {
                $popup.hide();
            }
        }
    }

    var clearPopupItems = function($popupItems) {
        $popupItems.removeData("selected");
        $popupItems.removeClass("hover");
    };

    var selectItem = function($correctLi) {
        $correctLi.data("selected", true);
        $correctLi.addClass("hover");
    };

    var findSelected = function($popupItems) {
        var $toReturn = undefined;
        $popupItems.each(function() {
            if ($(this).data('selected')) {
                $toReturn = $(this);
            }
        });
        return $toReturn;
    };

    var findCorrectSelectedLi = function($popupItems, next) {
        var $foundSelected = findSelected($popupItems);
        if (typeof $foundSelected === "undefined") {
            return $popupItems.first();
        }

        if (next) {
            return $foundSelected.next();
        } else {
            return $foundSelected.prev();
        }
    };

    function togglePopupSelect(event) {
        var $popup = $(suggestionPopupSelector);
        var $popupList = $(suggestionListSelector);
        var $popupItems = $(suggestionListItemSelector);
        var $correctLi;
        var $selectedLi;

        if ($popup.is(":visible")) {
            switch (event.key) {
                case "ArrowDown":
                    $correctLi = findCorrectSelectedLi($popupItems, true);
                    clearPopupItems($popupItems);
                    selectItem($correctLi);
                    scrollPopup($correctLi, $popupList);
                    event.preventDefault();
                    break;
                case "ArrowUp":
                    $correctLi = findCorrectSelectedLi($popupItems, false);
                    clearPopupItems($popupItems);
                    selectItem($correctLi);
                    scrollPopup($correctLi, $popupList);
                    event.preventDefault();
                    break;
                case "Enter":
                    $selectedLi = findSelected($popupItems);
                    onSelectSuggestion($selectedLi, data[$popupList.data('suggestion-type')]);
                    $popup.hide();
                    event.preventDefault();
                    break;
                case "Escape":
                    $popup.hide();
                    clearPopupItems($popupItems);
                    event.preventDefault();
                    break;
            }
        }
    }

    var scrollPopup = function($correctLi, $popupList) {
        var itemPosition = $correctLi.position();
        if (itemPosition !== undefined) {
            $popupList.scrollTop($popupList.scrollTop() + itemPosition.top - $popupList.height()/2 + $correctLi.height()/2);
        }
    };

    var showPopupForSelectedField = function($selectedField){
        $selectedField.parent().css({
            position: "relative"
        });
        var pos = $selectedField.position();

        if ($(suggestionListSelector).text().length > 0){
            $(suggestionPopupSelector).css({
                position: "absolute",
                left: (pos.left + parseInt($selectedField.css('marginLeft'), 10)) + "px",
                top: ($selectedField.outerHeight() + $selectedField.position().top) + "px",
                width: $selectedField.outerWidth() + "px"
            });
        }
    };

    var STREET_PREFIX_CANONICAL_MAP = {
        'str': 'str',
        'strada': 'str',
        'ale': 'ale',
        'aleea': 'ale',
        'int': 'int',
        'intrarea': 'int',
        'fdt': 'fdt',
        'fundatura': 'fdt',
        'fundătura': 'fdt',
        'pta': 'pta',
        'piata': 'pta',
        'piața': 'pta',
        'bld': 'bld',
        'bulevardul': 'bld',
        'drm': 'drm',
        'drumul': 'drm',
        'cal': 'cal',
        'calea': 'cal',
        'sos': 'sos',
        'soseaua': 'sos',
        'șoseaua': 'sos'
    };

    var STREET_PREFIX_SEARCH_FALLBACK_MAP = {
        'strada': 'str',
        'aleea': 'ale',
        'intrarea': 'int',
        'fundatura': 'fdt',
        'fundătura': 'fdt',
        'piata': 'pta',
        'piața': 'pta',
        'bulevardul': 'bld',
        'drumul': 'drm',
        'calea': 'cal',
        'soseaua': 'sos',
        'șoseaua': 'sos'
    };

    function normalizeStreetForCompare(value) {
        if (value === undefined || value === null) {
            return '';
        }

        var normalized = String(value)
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');

        normalized = normalized.replace(/\./g, ' ');
        normalized = normalized.replace(/,/g, ' ');
        normalized = normalized.replace(/\s+/g, ' ').trim();

        if (normalized.length === 0) {
            return '';
        }

        var tokens = normalized.split(' ');
        if (tokens.length > 0) {
            var firstToken = tokens[0];
            if (STREET_PREFIX_CANONICAL_MAP[firstToken] !== undefined) {
                tokens[0] = STREET_PREFIX_CANONICAL_MAP[firstToken];
            }
        }

        return tokens.join(' ');
    }

    function getStreetNamePart(normalizedStreet) {
        if (normalizedStreet === undefined || normalizedStreet === null || normalizedStreet.length === 0) {
            return '';
        }

        var tokens = normalizedStreet.split(' ');
        if (tokens.length === 0) {
            return '';
        }

        if (STREET_PREFIX_CANONICAL_MAP[tokens[0]] !== undefined) {
            tokens.shift();
        }

        return tokens.join(' ').trim();
    }

    function splitStreetNameWords(streetName) {
        if (streetName === undefined || streetName === null || streetName.length === 0) {
            return [];
        }

        return streetName.split(' ').filter(function(token) {
            return token && token.length > 0;
        });
    }

    function streetsAreEquivalent(inputStreet, suggestionStreet) {
        var normalizedInput = normalizeStreetForCompare(inputStreet);
        var normalizedSuggestion = normalizeStreetForCompare(suggestionStreet);

        if (normalizedInput.length === 0 || normalizedSuggestion.length === 0) {
            return false;
        }

        if (normalizedInput === normalizedSuggestion) {
            return true;
        }

        var inputStreetName = getStreetNamePart(normalizedInput);
        var suggestionStreetName = getStreetNamePart(normalizedSuggestion);

        if (inputStreetName.length === 0 || suggestionStreetName.length === 0) {
            return false;
        }

        if (inputStreetName === suggestionStreetName) {
            return true;
        }

        var inputTokens = splitStreetNameWords(inputStreetName);
        var suggestionTokens = splitStreetNameWords(suggestionStreetName);

        if (inputTokens.length === 0 || suggestionTokens.length === 0) {
            return false;
        }

        return inputTokens.every(function(inputToken) {
            return suggestionTokens.some(function(suggestionToken) {
                return suggestionToken.indexOf(inputToken) !== -1;
            });
        });
    }

    function hydrateStreetSelectionFromCurrentValue() {
        var currentStreetValue = $(streetData.selector).val();

        if (currentStreetValue === undefined || currentStreetValue === null || currentStreetValue.length === 0) {
            setStreetSelectedFromSuggestion(false);
            setLastValidatedStreet('');
            streetData.selectedSuggestion.name = undefined;
            streetData.selectedSuggestion.displayName = undefined;
            return;
        }

        if (isEmptyList(streetData.suggestionList)) {
            var normalizedCurrentStreet = normalizeStreetForCompare(currentStreetValue);
            var normalizedLastValidated = normalizeStreetForCompare(getLastValidatedStreet());
            if (normalizedCurrentStreet.length > 0 && normalizedCurrentStreet === normalizedLastValidated) {
                setStreetSelectedFromSuggestion(true);
                return;
            }
            setStreetSelectedFromSuggestion(false);
            setLastValidatedStreet('');
            return;
        }

        for (var i = 0; i < streetData.suggestionList.length; i++) {
            var suggestionDisplayName = getStreetSuggestionName(streetData.suggestionList[i]);
            if (streetsAreEquivalent(currentStreetValue, suggestionDisplayName)) {
                streetData.selectedSuggestion.name = suggestionDisplayName;
                streetData.selectedSuggestion.displayName = suggestionDisplayName;
                setStreetSelectedFromSuggestion(true);
                setLastValidatedStreet(suggestionDisplayName);
                return;
            }
        }

        setStreetSelectedFromSuggestion(false);
        setLastValidatedStreet('');
        streetData.selectedSuggestion.name = undefined;
        streetData.selectedSuggestion.displayName = undefined;
    }

    function getLastValidatedStreet() {
        if (lastValidatedStreetField && lastValidatedStreetField.length) {
            return lastValidatedStreetField.val() || '';
        }
        return '';
    }

    function setLastValidatedStreet(streetValue) {
        if (lastValidatedStreetField && lastValidatedStreetField.length) {
            lastValidatedStreetField.val(streetValue || '');
        }
    }

    var setStreetSelectedFromSuggestion = function(isSelected) {
        if (streetSelectedFlagField && streetSelectedFlagField.length) {
            streetSelectedFlagField.val(isSelected ? 'true' : 'false');
        }
    };

    var getCountryCode = function() {
        var countryCode;
        if (countryCodeSel) {
            countryCode = $(countryCodeSel).val();
        } else {
            countryCode = undefined;
        }
        return countryCode;
    };

    var updateTextHolder = function(localData, text) {
        localData.textHolderReset = false;
        if (localData.textHolder !== text) {
            localData.textHolder = text;
            Object.keys(data).forEach(function(key) {
                if (key !== localData.id) {
                    data[key].textHolderReset = true;
                }
            });
        }
    };

    return {
        handleLocationFieldKeyUp: handleLocationFieldKeyUp,
        handleLocationFieldFocus: handleLocationFieldFocus,
        handleLocationFieldFocusOut: handleLocationFieldFocusOut,
        handleZipCodeFieldKeyUp: handleZipCodeFieldKeyUp,
        handleZipCodeFieldFocus: handleZipCodeFieldFocus,
        handleZipCodeFieldFocusOut: handleZipCodeFieldFocusOut,
        handleStreetFieldKeyUp: handleStreetFieldKeyUp,
        handleStreetFieldFocus: handleStreetFieldFocus,
        handleStreetFieldFocusOut: handleStreetFieldFocusOut,
        togglePopup: togglePopup,
        togglePopupSelect: togglePopupSelect
    };
};